import React, { useEffect, useState } from 'react';
import WaveNavigation from './components/WaveNavigation';
import LandingPage from './components/LandingPage';
import { PovProvider, Pov } from './context/PovContext';
import { UIProvider } from './context/UIContext';
import './App.css';
import { RoadMapPage } from './pages';
import blurpleLogo from './assets/blurple.png';

function App() {
  const [showLanding, setShowLanding] = useState(true);
  const [pov, setPov] = useState<Pov>('man');
  const [showRoadmap, setShowRoadmap] = useState<boolean>(false);

  const handleEnterApp = (selected: Pov) => {
    setPov(selected);
    setShowLanding(false);
  };

  // Set site favicon to blurple logo
  useEffect(() => {
    const setFavicon = (href: string) => {
      let link = document.querySelector("link[rel='icon']") as HTMLLinkElement | null;
      if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.head.appendChild(link);
      }
      link.type = 'image/png';
      link.href = href;

      // Apple touch icon for iOS
      let apple = document.querySelector("link[rel='apple-touch-icon']") as HTMLLinkElement | null;
      if (!apple) {
        apple = document.createElement('link');
        apple.rel = 'apple-touch-icon';
        document.head.appendChild(apple);
      }
      apple.href = href;
    };

    setFavicon(blurpleLogo);
  }, []);

  if (showLanding) {
    return (
      <div className="App">
        <div className="landing-background">
          <div className="wave-navigation-container">
            <div className="phone">
              <div className={`page-content-area ${showRoadmap ? 'no-padding' : ''}`}>
                {showRoadmap ? (
                  <RoadMapPage onBack={() => setShowRoadmap(false)} />
                ) : (
                  <LandingPage 
                    onEnter={handleEnterApp} 
                    onOpenRoadmap={() => setShowRoadmap(true)} 
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="App">
      <PovProvider initialPov={pov}>
        <UIProvider>
          <WaveNavigation />
        </UIProvider>
      </PovProvider>
    </div>
  );
}

export default App;
